import { Suspense, lazy } from 'react';
import Modal from './Modal';
import Button from './Button';
import useCopy from '../util/useCopy';

let QrCodeRenderer = lazy(() => import('./QrCodeRenderer'));

let QrCodeModal = ({
  isOpen,
  onClose,
  url,
  leagueName,
}: {
  isOpen: boolean;
  onClose: () => void;
  url: string;
  leagueName: string;
}) => {
  let copy = useCopy();

  return (
    <Modal isOpen={isOpen} onClose={onClose}>
      <div className="flex min-h-0 flex-1 flex-col items-center justify-center p-5">
        <div className="mb-1 text-lg font-bold text-purple-900">
          {leagueName}
        </div>
        <div className="mb-4 text-sm text-neutral-500">{copy.scanToJoin}</div>
        <div className="rounded-2xl border-4 border-purple-900 overflow-hidden shadow-lg">
          <Suspense fallback={<Modal.Loader />}>
            <QrCodeRenderer url={url} />
          </Suspense>
        </div>
      </div>
      <Modal.BottomActions>
        <Button onClick={onClose}>{copy.Done}</Button>
      </Modal.BottomActions>
    </Modal>
  );
};

export default QrCodeModal;
